<div class="timesheet-picker">
    <!--
        A span rather than a label: the select field's trigger is a button with no id to point at,
        and it carries its own accessible name through `ariaLabel`.
    -->
    <span class="form-label" translate="TIMESHEET_PICKER_LABEL"></span>
    <pace-select-field
        [value]="selection()"
        (valueChange)="onSelectionChange($event)"
        [options]="options()"
        [deselectable]="false"
        [ariaLabel]="'TIMESHEET_PICKER_SELECT_LABEL' | translate"
    ></pace-select-field>
</div>
